import React, { useCallback, useMemo } from 'react'

// import { ReactComponent as AcceptIcon } from './../../../projectSubCategory/accept-icon.svg'
import { ReactComponent as DeclineIcon } from './../../../projectSubCategory/decline-icon.svg'
import { ReactComponent as AcceptPendingIcon } from './accept-pending-icon.svg'
import { ReactComponent as DeclinePendingIcon } from './reject-pending-icon.svg'

import { AcceptIcon } from './../../../projectSubCategory/accept-icon'

import './PendingPostLabel.css'
import { SidekickCategories } from '../../../../static/categories'

export const responsePendingTypes = {
    decline: 'declinePendingPost',
    accept: 'acceptPendingPost',
}

const PendingPostLabel = ({ category, subCategoryTitle, subCategories, onAcceptDecline }) => {

    const color = useMemo(() => SidekickCategories[category.toLowerCase()]?.color || '#30CC9D', [category])

    const style = useMemo(() => {
        return {
                backgroundColor: color,
            }
    }, [SidekickCategories]);

    const handleAcceptDecline = useCallback(e => {
        e.stopPropagation()
        onAcceptDecline(e)
    }, [onAcceptDecline])

    return (
        <>
            {
                subCategoryTitle === subCategories.pending &&
                <div className='pending-buttons-wrap'>
                    <button
                        type='button'
                        data-type={responsePendingTypes.decline}
                        className='pending-button decline-pending-button'
                        onClick={handleAcceptDecline}
                    >
                        <DeclinePendingIcon />
                        <span>
                            Reject
                        </span>
                    </button>
                    <button
                        style={style}
                        type='button'
                        data-type={responsePendingTypes.accept}
                        className='pending-button'
                        onClick={handleAcceptDecline}
                    >
                        <AcceptPendingIcon />
                        <span>
                            Approve
                        </span>
                    </button>
                </div>
            }
            {
                subCategoryTitle === subCategories.rejected &&
                <div className='reject-approve-label-wrap'>
                    <span>Rejected</span>
                    <DeclineIcon />
                </div>
            }
            {
                subCategoryTitle === subCategories.approved &&
                <div className='reject-approve-label-wrap'>
                    <span>Approved</span>
                    <AcceptIcon color={color}/>
                </div>
            }
        </>
    )
}

export default PendingPostLabel